<template lang="pug">
.form-article.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container
        input.input(v-model="dataForm.article" autocomplete="ño" :disabled="fillData" required)
        label.label(:class="{ show: dataForm.article }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="article" title="Artículo Ingles")

      .input-container
        input.input(v-model="dataForm.letter" autocomplete="ño" :disabled="fillData" minlength="1" maxlength="1" required)
        label.label(:class="{ show: dataForm.letter }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="letter" title="Letra")

      .input-container
        input.input(v-model="dataForm.spanish" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.spanish }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="spanish" title="Artículo Español")

      .input-container
        input.input(v-model.number="dataForm.order" type="number" autocomplete="ño" required)
        label.label(:class="{ show: Number.isInteger(dataForm.order) }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="order" title="Orden")

      .input-container
        select.select(v-model="dataForm.folder" autocomplete="ño" required)
          option(v-for="folder in folders" :value="folder") {{ folder }}
        label.label(:class="{ show: dataForm.folder }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="folder" title="Carpeta")

      shInputImage(:dataForm="dataForm" :dataOriginal="dataOriginal" title="Imagen" property="image" :folder="dataForm.folder" @load="imageLoaded = true" @error="imageLoaded =  false" :noImagePath="noImagePathArticle" :classContainerImage="classContainerImage" :imagePath="imagePath")

      .left
        h3 Activo en Marca

      .input-container.arrow(v-for="(brand, index) in brands")
        select.select(v-model="dataForm.activeArticle[index]" autocomplete="ño" required)
          option(:value="true") Activo
          option(:value="false") Inactivo
        label.label(:class="{ show: dataForm.activeArticle[index] }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="activeArticle" :index="index" :title="brand")

      shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteArticle")
</template>

<script>
import mForm from '@/mixins/form'
import mDB from '@/mixins/db'
import gqlArticle from '@/graphql/article'
import shDeleteButton from '@/components/elements/DeleteButton'
import shInputImage from '@/components/elements/InputImage'
import shProperty from '@/components/elements/Property'

export default {
  name: 'FormArticle',

  mixins: [mForm, mDB],

  components: { shDeleteButton, shInputImage, shProperty },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        article: '',
        spanish: '',
        image: '',
        letter: '',
        folder: '',
        order: '',
        activeBrands: [],
        activeArticle: []
      },
      resolver: 'article',
      key: 'article',
      gql: gqlArticle,
      imageLoaded: false,
      classContainerImage: 'button-article'
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  mounted () {
    this.dataForm.activeBrands = this.brands
  },

  methods: {
    sendForm () {
      if (this.imageLoaded) {
        if (!this.fillData) {
          this.newArticle()
        } else {
          this.updateArticle()
        }
      }
    },

    newArticle () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateArticle () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteArticle () {
      this.deleteData(this.gql, this.resolver, this.key)
    }
  },

  computed: {
    folders () {
      return this.$store.state.folders
    },
    brands () {
      return this.$store.state.variables.brands
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-article
  position relative

.button-article
  border none
  border-radius .8em
  //borderRadius(.8em)
  font-size 1.2em
  font-weight 600
  transition all .2s ease-in
  box-shadow 0px 0px 20px -2px rgba(0, 0, 0, .9)
  display inline-flex
  height 4em
  width 4em
  justify-content space-around
  //boxShadow(0px 8px 20px -2px rgba(0, 0, 0, .9))

.button-article:hover
  box-shadow 0px 0px 20px -2px #ffdc65

.button-article img
  align-self center
  height 2.2em
  width 2.2em
</style>



// WEBPACK FOOTER //
// src/components/pages/article/Form.vue